export const equipmentTypes = [
  {
    label: "Notebook",
    value: "notebook",
    prefix: "NTB",
  },
  {
    label: "Monitor",
    value: "monitor",
    prefix: "MTR",
  },
  {
    label: "Suporte Notebook",
    value: "suporte-notebook",
    prefix: "SPT"
  },
  {
    label: "Impressora",
    value: "impressora",
    prefix: "IMP"
  },
  {
    label: "Headset",
    value: "headset",
    prefix: "HST",
  },
  {
    label: "Mouse e Teclado",
    value: "mouse-keyboard",
    prefix: "KTM",
  },
  {
    label: "Mouse",
    value: "mouse",
    prefix: "MOU",
  },
  {
    label: "Cadeira",
    value: "cadeira",
    prefix: "CDR",
  },
  {
    label: "Mesa",
    value: "mesa",
    prefix: "MSA"
  },
  {
    label: "Hub USB",
    value: "hub-usb",
    prefix: "HUB",
  },
];

export const techBrands = [
  { value: "apple", label: "Apple" },
  { value: "asus", label: "Asus" },
  { value: "acer", label: "Acer" },
  { value: "dell", label: "Dell" },
  { value: "hp", label: "HP" },
  { value: "lenovo", label: "Lenovo" },
  { value: "msi", label: "MSI" },
  { value: "samsung", label: "Samsung" },
  { value: "lg", label: "LG" },
  { value: "sony", label: "Sony" },
  { value: "toshiba", label: "Toshiba" },
  { value: "razer", label: "Razer" },
  { value: "logitech", label: "Logitech" },
  { value: "corsair", label: "Corsair" },
  { value: "hyperx", label: "HyperX" },
  { value: "steelseries", label: "SteelSeries" },
  { value: "coolermaster", label: "Cooler Master" },
  { value: "gigabyte", label: "Gigabyte" },
  { value: "nvidia", label: "NVIDIA" },
  { value: "amd", label: "AMD" },
  { value: "intel", label: "Intel" },
  { value: "microsoft", label: "Microsoft" },
  { value: "huawei", label: "Huawei" },
  { value: "xiaomi", label: "Xiaomi" },
  { value: "oneplus", label: "OnePlus" },
  { value: "anker", label: "Anker" },
  { value: "tp-link", label: "TP-Link" },
  { value: "netgear", label: "Netgear" },
  { value: "sandisk", label: "SanDisk" },
  { value: "kingston", label: "Kingston" },
  { value: "seagate", label: "Seagate" },
  { value: "western-digital", label: "Western Digital" },
  { value: "synology", label: "Synology" },
  { value: "qnap", label: "QNAP" },
  { value: "epson", label: "Epson" },
  { value: "canon", label: "Canon" },
  { value: "brother", label: "Brother" },
  { value: "benq", label: "BenQ" },
  { value: "viewsonic", label: "ViewSonic" },
  { value: "philips", label: "Philips" },
  { value: "zowie", label: "Zowie" },
  { value: "thermaltake", label: "Thermaltake" },
  { value: "evga", label: "EVGA" },
  { value: "adata", label: "ADATA" },
  { value: "crucial", label: "Crucial" },
  { value: "beats", label: "Beats by Dre" },
  { value: "bose", label: "Bose" },
  { value: "jbl", label: "JBL" },
  { value: "sony-audio", label: "Sony (Áudio)" },
  { value: "sennheiser", label: "Sennheiser" },
  { value: "plantronics", label: "Plantronics" },
  { value: "astro", label: "Astro Gaming" },
]; 